<template>
  <div class="invadobay-preview__side-card">
    <!-- properties -->
    <invadobay-search-preview-properties
      :invadobay="elem"
      :loading="loading"
      :properties="properties"
    />

    <!-- content -->
    <b-card class="invadobay-preview__side-card__info card">
      <div class="h-100 d-flex flex-column gap-3 justify-content-center">
        <custom-link
          :route_path="`/invadobay/${elem.slug}`"
          :wrapper_class="'invadobay-preview__side-card__info_title'"
          :as_default="get_config('guiSettings.openDetailNewTab', false)"
        >
          <template #content>
            {{ elem.title }}
          </template>
        </custom-link>
        <p
          v-if="elem.description"
          ref="description_text"
          :id="`description_text-${elem.description}-${_uid}`"
          class="invadobay-preview__side-card__info_description" 
        >
          {{ elem.description }}
        </p>
        <b-popover
          v-if="description_tooltip"
          :target="`description_text-${elem.description}-${_uid}`"
          triggers="hover"
          placement="bottom"
          custom-class="b-popover--dark b-popover--no-arrow"
        >
          <span class="text--base">
            {{ description_tooltip }}
          </span>
        </b-popover>
        <p class="w-100 d-flex justify-content-end">
          <custom-link
            :route_path="`/invadobay/${elem.slug}`"
            :css_class="'text-info link'"
            :as_default="get_config('guiSettings.openDetailNewTab', false)"
          >
            <template #content> Vedi tutte le proposte </template>
          </custom-link>
        </p>
      </div>
    </b-card>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { search_invadobay_preview_properties } from "./utilities";
import { get_config } from "@/utilities/commons";
import InvadobaySearchPreviewProperties from "./invadobay-search-preview-properties.vue";

export default {
  name: "invadobay-search-preview",
  components: {
    "invadobay-search-preview-properties": InvadobaySearchPreviewProperties,
  },
  props: {
    elem: Object,
  },
  data() {
    return {
      loading: true,
      properties: [],
      description_tooltip: "",
    };
  },
  computed: {
    ...mapState(["occupancy"]),
  },
  mounted() {
    const search_promise = search_invadobay_preview_properties(
      this.elem,
      this.occupancy
    );
    if (search_promise) {
      search_promise
        .then((success) => {
          this.properties = success.data.data.properties;
        })
        .finally(() => {
          this.loading = false;
        });
    }
    this.$nextTick(() => {
      this.description_tooltip = this.is_text_truncated(
        this.$refs.description_text
      )
        ? this.elem.description
        : "";
    });
  },
  methods: {
    get_config,
  },
};
</script>

<style lang="scss" scoped>
.invadobay-preview__side-card {
  margin-bottom: $grid-gutter-width;
  display: grid;
  grid-template-columns: 100%;
  gap: 5px;

  @include media-breakpoint-up(lg) {
    gap: 15px;
    grid-template-columns: min(50%, 345px) auto;
  }

  &__info {
    border-radius: $border-radius-lg * 2 !important;
    border: 0px;
    display: flex;
    flex-direction: column;
    justify-content: center;

    &_title {
      color: black;
      font-size: $font-size-xl;
      font-weight: $vb-font-weight-semibold;
      text-decoration: underline;
    }

    &_link {
      color: $info;
      font-weight: $vb-font-weight-semibold;
      text-decoration: underline;
    }

    &_description {
      height: 4lh;

      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 4; /* Limita a 3 righe */

      box-orient: vertical;
      line-clamp: 4;

      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
}
</style>
